import React from 'react';
import CSelect, { Error } from 'src/components/form/Select';
import { ActionMeta, Props } from 'react-select';
import _ from 'lodash';
import { billingTypeOptions } from 'src/api/types';
import { BillingType } from 'src/graphql/_generated';

interface BillingTypeSelectProps extends Omit<Props, 'value' | 'options'> {
  value: BillingType | undefined | null;
  onChange: (value: { label: string; value: BillingType }, meta: ActionMeta<any>) => void;
  onBlur?: () => void;
  error?: boolean;
  helperText?: string | false;
  disabled?: boolean;
  placeholder?: string;
  filteredOptions?: BillingType[];
}

export const BillingTypeSelect: React.FC<BillingTypeSelectProps> = ({
  value,
  onChange,
  onBlur,
  error,
  helperText,
  disabled,
  placeholder = 'Select billing type',
  filteredOptions,
  ...rest
}) => {
  const options = filteredOptions?.length
    ? billingTypeOptions.filter((option) => filteredOptions.includes(option.value))
    : billingTypeOptions;

  const selectedValue = value ? _.find(options, (o) => o.value === value) : null;

  return (
    <>
      <CSelect
        isDisabled={disabled}
        value={selectedValue}
        placeholder={placeholder}
        options={options}
        onChange={onChange}
        onBlur={onBlur}
        inputId="billing-type-select"
        name="billingType"
        {...rest}
      />
      {error && helperText && <Error>{helperText}</Error>}
    </>
  );
};
